import { SensorConversions } from "../conversionFunctions/sensorConversions.js";
import { SensorElementConfig } from "./types.js";

export const volumetricWaterContentElementConfig: SensorElementConfig<
    Record<string, never>,
    typeof SensorConversions.unity
> = {
    legalConvertedRange: [0, 100],
    conversionKey: "unity",
    parameterConfigs: {},
    buildConversionParams: () => ({}),
    decodedUnits: "percent",
    convertedUnits: "percent",
    unitCategory: "volumetricSoilMoisture",
    testCases: [
        { parameters: {}, decodedValue: 25.0, convertedValue: 25.0 },
        { parameters: {}, decodedValue: 0.0, convertedValue: 0.0 },
        { parameters: {}, decodedValue: 60.0, convertedValue: 60.0 },
    ],
} as const;
